import { ChildrenProps, PageLoader } from '@dfl/mui-react-common';
import { SxProps } from '@mui/material';
import { AuthLayout } from 'layouts';
import { memo, Suspense } from 'react';

type AuthAppLayoutProps = ChildrenProps & { className?: string, sx?: SxProps, maxWidth?: number };

const AuthAppLayout = ({ children, className, sx, maxWidth }: AuthAppLayoutProps) => {
  return (
    <AuthLayout className={className} sx={sx} maxWidth={maxWidth}>
      <Suspense fallback={<PageLoader size={500} />}>{children}</Suspense>
    </AuthLayout>
  );
};

export default memo(AuthAppLayout);
